<template>
    <section class="primaryInfo">
        <a name="home" style=" position: relative;top: -420px;display: block;height: 0;overflow: hidden;"></a>
        <NavCrumbs :crumbProp="crumbProp" v-show="isPc"></NavCrumbs>
       
        <section class="information">
            <section class="innerBox">
                <NewsMenu :isActive="isActive"></NewsMenu>
                <NewsBar></NewsBar> 
                <div class="info">
                    <h1>Celebrate EID with ToTok!</h1>
                    
                        <span class="sub_date">May 11, 2021</span>

<p><br/>🌙✨EID Mubarak! ✨🌙

<p>We’ve been through a lot together this past year. Thank you for staying strong and optimistic despite the hardship.</p>
<p>For Eid 2021, we want to bring some joy and fortune to our ToTok community, which is why we have prepared an Eidiya for everyone<sup>1</sup>. (Unfortunately, our payment service is currently only available for Android users in the UAE, so only UAE numbers are eligible to receive eidiya.)</p>
<p>You have one Eidiya by default, but if you want more, you can invite your friends to join ToTok. For each friend you successfully invite<sup>2</sup>, you will get a ticket. If your friend uses a UAE number, they get a ticket too!</p>
<p>Come join us in the Eidiya Challenge and help grow our community! See you on ToTok!</p>
<p>Sent with love,<br/>ToTok</p>
<hr>

<p><sup>1</sup> Pleae check rules of activity for details. ToTok reserves the final right of interpretation of this activity. </p>
<p><sup>2</sup> A successful invite: Your friend downloads, registers and logs in ToTok using the referral link you sent. </p>
<h2>How to join?</h2>

<p>1. Log in to ToTok with a UAE phone number</p>
<p>2. Join the Eidiya Challenge and get your eidiya</p>
<br>
<img
    src="../assets/img/web_mockup.png"
    alt="web mockup"
    style="width: 100%;"
/>
<p>3. Invite friends to get more eidiya!</p>
<h2>Rules of Activity</h2>
<p>1. The Eidiya Challenge is effective from 13 May 2021 12:00:00 AM (GMT +04) to 31 May 2021 11:59:59 PM (GMT +04). Any un-used ticket will expire after 31 May 2021 11:59:59 PM (GMT +04).</p>
<p>2. You have 1 free ticket to enter the lucky draw.</p>
<p>3. To get more tickets, click the refer button to share ToTok with your friend(s). When your friend(s) downloads and registers ToTok using your link, you will automatically receive a ticket.</p>
<p>4. The amount of cash prize (or GreenPoints, which are cash-equivalent coupons) is distributed at random.</p>
<p>5. In accordance with UAE laws and regulations, cash will be deposited in your PayBy account directly if you have a verified account with PayBy. Otherwise, GreenPoints will be sent to your account directly.</p>
<p>6. Remember, the more people you refer, the more tickets you get!</p>
<p>7. ToTok reserves the right of final interpretation of this campaign.</p>
</p>

                </div>
                <!-- <div class="cp">All rights reserved, 2020 © Totok Pte. Ltd.</div> -->
            </section>
        </section>
        <Footer></Footer>
     <FootBanner ></FootBanner>
    </section> 
</template>

<script>
import NewsBar from '@/components/NewsBar.vue'
import NavCrumbs from '@/components/NavCrumbs.vue'
import NewsMenu from '@/components/NewsMenu.vue'
import FootBanner from '@/components/FootBanner.vue'
import Footer from '@/components/Footer.vue'

    export default {
        name:"Jun202015",
        metaInfo() {
            return {
                title: 'Introducing New Features on ToTok',
                // meta: [{
                //     vmid: 'og:title',
                //     property: 'og:title',
                //     name: 'og:title',
                //     content: 'Terms of Use - ToTok Messenger',
                // },{
                //     vmid:"og:description",
                //     property: 'og:description',
                //     name: 'og:description',
                //     content: 'Enjoy FREE, FAST and FUN calling with your family and friends.'
                // },]
                meta: [
                    {property: 'og:title', content: 'Introducing New Features on ToTok'},
                    {property:  'og:description', content: 'Introducing New Features on ToTok'},
                    {property: 'og:url', content: 'https://totok.ai/eidiya-with-totok'},
                    {property: 'og:type', content: 'website'},
                    {property: 'og:image', content: 'https://static.totok.ai/pic/preview/free_unblocked_call.png'},
                    {property: 'og:site_name', content: 'ToTok'}
                ]
            }
        },
        components: {
            NewsBar,
            NavCrumbs,
            NewsMenu,
             Footer,
            FootBanner
        },
        data() {
            return {
                showinfo: false,
                isActive: 'May202111',
                crumbProp:{
                    label:"Recent News", 
                    type:"simple"
                },
                leftMenus: [
                    {
                        title: 'Mar 23',
                        anchorId: "newsMar202023"
                    },
                    {
                        title: 'Mar 11',
                        anchorId: "newsMar202011"
                    },
                    {
                        title: 'Mar 05',
                        anchorId: "newsMar202005"
                    },
                    {
                        title: 'Feb 23',
                        anchorId: "newsFeb20200223"
                    },
                    {
                        title: 'Feb 20',
                        anchorId: "Feb202020"
                    },
                    {
                        title: 'Jan 05',
                        anchorId: "Jan05"
                    },
                    {
                        title: 'Dec 29',
                        anchorId: "Dec29"
                    },
                    {
                        title: 'Dec 27',
                        anchorId: "Dec27"
                    },
                    {
                        title: 'Dec 24',
                        anchorId: "Dec24"
                    },
                    {
                        title: 'Dec 23',
                        anchorId: "Dec23"
                    }
                ]
            };
        },
        computed: {
            info() {
                return []
            },
            isPc(){
                 return document.body.offsetWidth > 450; 
            },isIOS() {
      return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0;
    },
        },
        methods: {
            gotoHandle(palice) {
                console.log('palice',palice)
                switch (palice) {
                    case "newsMar202023":
                        this.isActive = 'newsMar202023'
                        this.$router.push({name:'newsMar202023'})
                        break;
                    case "newsMar202011":
                        this.isActive = 'newsMar202011'
                        this.$router.push({name:'newsMar202011'})
                        break;
                    case "newsMar202005":
                        this.isActive = 'newsMar202005'
                        this.$router.push({name:'newsMar202005'})
                        break;
                    case "newsFeb20200223":
                        this.isActive = 'newsFeb20200223'
                        this.$router.push({name:'newsFeb20200223'})
                        break;
                    case "Feb202020":
                        this.isActive = 'Feb202020'
                        this.$router.push({name:'newsFeb202020'})
                        // this.mainPannel.scrollTo(0, 2000)
                        break;
                    case "Jan05":
                        this.isActive = 'Jan05'
                        this.$router.push({name:'newsJan05'})
                        // this.mainPannel.scrollTo(0, 2000)
                        break;
                    case "Dec29":
                        this.isActive = 'Dec29'
                        this.$router.push({name:'newsDec29'})
                        // this.mainPannel.scrollTo(0, 2000)
                        break;
                    case "Dec27":
                        this.isActive = 'Dec27'
                        this.$router.push({name:'newsDec27'})
                        // this.mainPannel.scrollTo(0, 2000)
                        break;
                    case "Dec24":
                        this.isActive = 'Dec24'
                        this.$router.push({name:'newsDec24'})
                        // this.mainPannel.scrollTo(0, 2000)
                        break;
                     case "Dec23":
                        this.isActive = 'Dec23'
                        // this.$router.push({name:'newsDec22'})
                        // this.mainPannel.scrollTo(0, 0)
                        this.$router.push({name:'newsDec22'})
                        break;
                    
                }
            }
        }
    }
</script>
<style scoped lang="stylus">
      @media only screen and (max-width: 700px) {
        .primaryInfo {
            // padding: 0.8rem;
            background: #fff;
            height: 106vh;
            .innerBox {
                padding-bottom: 50px; 
            }
            .leftMenu {
                display none
            }

            div {
                margin-left: 20px;
                margin-right: 20px;
            }

            .info {


                h1 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 28px;
                    font-weight: 400;
                    color: #222222;
                    -webkit-font-smoothing: antialiased;
                    padding-bottom: 20px;
                    padding-top: 40px;
                    margin: 0px;
                    line-height: 40px;
                }

                h2 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 24px;
                    font-weight: 400;
                    color: #4377f2;
                    -webkit-font-smoothing: antialiased;
                    padding-bottom: 18px;
                    padding-top: 28px;
                    margin: 0px;
                }

                h3 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: 400;
                    color: #808080;
                    padding-bottom: 20px;
                    margin: 0;
                }

                h6 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-style: italic;
                    font-size: 16px;
                    font-weight: bold;
                    margin-bottom: 12px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                p {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-bottom: 12px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                ul {
                    list-style: disc;
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-top: 0;
                    margin-bottom: 10px;
                    margin-left: 24px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                li {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-top: 0px;
                    margin-bottom: 10px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                    margin-left: 20px;
                }

                a {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-bottom: 12px;
                    color: #4377f2;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }
            }
        }

        .cp {
            height: 3.5rem;
            font-size: 13px;
            color: #808080;
            line-height: 3.5rem;
            text-align: center;
        }
    }

    @media only screen and (min-width: 701px) {
        .primaryInfo {
            padding-top: 102px;
            width: 100vw;
            background: #fff;

            .information {
                margin: 0 auto;
                width: 800px;

                .innerBox {
                    position relative;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: flex-end;
                    height: 83vh;
                    overflow: auto;
                        

                    .leftMenu {
                        position: absolute;
                        left: 0px;
                        top: 39px;
                        display flex;
                        flex-direction column;
                        justify-content center;
                        align-items: flex-start;
                        list-style none;

                        .menu-item {
                            color: #979797;
                            margin-top: 30px;
                            cursor pointer;
                            text-decoration none;
                            font-size: 15px;
                        }

                        .menu-item:nth-child(1) {
                            margin-top: 0px;
                        }

                        .menu-item--active {
                            color: #000;
                            border-bottom: 2px solid #4377f2;
                        }

                    }
                }
            }

            .info {
                width: 550px;
                margin: 20px 0;
margin-bottom:60px;
                h1 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 28px;
                    font-weight: 400;
                    color: #222222;
                    -webkit-font-smoothing: antialiased;
                    padding-bottom: 20px;
                    padding-top: 20px;
                    margin: 0px;
                    line-height: 40px;
                }

                h2 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 24px;
                    font-weight: 400;
                    color: #4377f2;
                    -webkit-font-smoothing: antialiased;
                    padding-bottom: 18px;
                    padding-top: 28px;
                    margin: 0px;
                }

                h3 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: 400;
                    color: #808080;
                    padding-bottom: 20px;
                    margin: 0;
                }

                h6 {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-style: italic;
                    font-size: 16px;
                    font-weight: bold;
                    margin-bottom: 12px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                p {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-bottom: 12px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                ul {
                    list-style: disc;
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-top: 0;
                    margin-bottom: 10px;
                    margin-left: 24px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }

                li {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-top: 0px;
                    margin-bottom: 10px;
                    color: #555555;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                    margin-left: 20px;
                }

                a {
                    font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                    font-size: 16px;
                    font-weight: normal;
                    margin-bottom: 12px;
                    color: #4377f2;
                    text-rendering: optimizeLegibility;
                    line-height: 26px;
                }
            }
        }

        .cp {
            height: 70px; 
            font-size: 13px;
            color: #808080;
            line-height: 70px;
            text-align: center;
        }
    }
</style>